import React, { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import Card from "lib/Card";
import Image from "lib/Image";
import DynamicForm from "components/DynamicForm";
import Group from "lib/Group";
import option from "../../assets/images/option.svg";
import "./index.scss";
import RequestChangeModal from "components/RequestChange/RequestChange";
import { Container,Row } from "react-bootstrap";
import Accordion from 'react-bootstrap/Accordion';
import { ActionButtons } from "lib/ActionButtons";
import { setPopupData } from "redux/popupReducer";
import { updateCrData } from "api/dashboardDetail";

import { sendreminderAboutStatus } from "api/dashboardDetail";


import ConfirmModal from "lib/ConfirmModal";
import RequestSectionModal from "lib/RequestSection/RequestSection";
import RequestSupportingDocuments from "lib/RequestSupportingDocuments/RequestSupportingDocuments";
import { cancelEmandate, postRequestedDocs, sendReminderForEsign } from "api/dashboardDetail";
import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
import PlaceHolderLoader from "components/PlaceHolderLoader";
import { RequestDocumentConfig } from "assets/RequestDocumentConfig";
import Toast from "components/ToastComponent";
import { IndirectEval } from "helper/indirectEval";
import { setSelectedData } from "redux/formDisplay";
const noPlaceholderItems = [
  "account_details",
  "account_number",
  // "user_details",
  "v-kyc_queue",
];

function ViewBlockCard(props) {
  const { form_item, selectedData: data, index,request_change_option } = props;
  const { options, title, name } = form_item;
  const [changeList, setChangeList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalOf, setShowModalOf] = useState({});
  const [blockSection, setBlockSection] = useState(1);
  const [blockGroup, setBlockGroup] = useState(1);
  const [keyValues, setKeyValues] = useState([]);
  const [blockName, setBlockName] = useState("");
  const [requestChangeKeys, setRequestChangeKeys] = useState([])
  const [customButton, setcustomButton] = useState(false);
  const [customClass, setCustomClass] = useState(false);
  const [blockId, setblockId] = useState("");
  const [popupState, setPopupState] = useState({});
  const [showPopModal, setShowPopModal] = useState(false);
  const [formErr, setFormErr] = useState({});
  const [assigneeRequired, setAssigneeRequired] = useState(false)
  const [roleValues,setRoleValues] = useState([]);
  const [userValues,setUservalues] =  useState([]);
  const [notificationValue,setNotificationValues] = useState([]);
  const organisationInfo = useSelector((state) => state?.loggedInUserInfo?.userAuthInfo?.organisationInfo);
  const { popupData } = useSelector((state) => state.popupReducer);
  const [sendReminderToast, setSendReminderToast] = useState({
    status: false,
    type: "",
    message: ""
  });
  const profileData = useSelector(
    (state) => state?.loggedInUserInfo?.userAuthInfo
  )?.profileInfo;
  const selectedDataFromRedux = useSelector(state => state.formData.selectedData);

  const dispatch = useDispatch();
  let selectedData =
    name === "account_details" || name === "account_number"
      ? data?.primaryworkflow
      : data?.subworkFlowInfo;

  selectedData = name === "payment_details" ? data : selectedData;
  const allData = { ...data };
    const completeData = {...data?.subworkFlowInfo,...popupData}

  const urlParams = useSelector((state) => state?.urlEncryption?.urlParams);
  // const urlParams = useParams();

  const currentSubWorkFlowId = useSelector(
    (state) => state?.dashboardDetailReducer?.currentSubWorkFlowId
  );
  const userSubworkFlowInfo = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo
  );
  const dashboardDetailData = useSelector(
    (state) =>
      state?.dashboardDetailReducer?.dashboardDetailData?.subworkFlowInfo
  );
  const userSubworkFlowInfoLoading = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfoLoading
  );
  const subworkflows = useSelector(
    (state) =>
      state?.dashboardDetailReducer?.dashboardDetailData?.subworkflows
  );
  const organisation_id = useSelector(
    (state) => state?.loggedInUserInfo?.userAuthInfo
  ).organisationInfo?._id;
  const [toastMessage, setToastMessage] = useState({
    status: false,
    type: "",
    message: ""
  });
  const getItemsWithData = useCallback((params) => {
    const key_values = [];

    const { section, group, title, form_elements, request_change_by_values = false } = form_item || {};
    setBlockSection(section);
    setBlockGroup(group);
    setBlockName(title);
    const skip = request_change_by_values ? false : params?.skip;

    const getKeys = (field) => {
      field?.forEach((item) => {
        if (item?.is_recursive && item?.input_fields?.length > 0) {
          item?.input_fields?.forEach((recursiveItem) => {
            const selectedDataValue =
              selectedData?.[item.form_field_items]?.[0]?.[recursiveItem.name];
            const show_in_request_change = recursiveItem?.show_in_request_change !== false || !params?.for_request_change_modal;
            if (show_in_request_change && (skip || selectedDataValue)) {
              const label = recursiveItem.tail
                ? ` ${recursiveItem.tail} - ${recursiveItem.label}`
                : recursiveItem.label;
              key_values.push({
                label,
                value: recursiveItem.name,
                dependentfield: recursiveItem.dependentfield,
              });
            }
          });
        } else if (item?.input_fields) {
          getKeys(item.input_fields);
        } else {
          const selectedDataValue = selectedData?.[item.name];
          const show_in_request_change = item?.show_in_request_change !== false || !params?.for_request_change_modal;
          if (show_in_request_change && (skip || selectedDataValue)) {
            const label = item.tail
              ? ` ${item.tail} - ${item.label}`
              : item.label;
            key_values.push({
              label,
              value: item.name,
              dependentfield: item.dependentfield,
            });
          }
        }
      });
    };

    getKeys(form_elements);
    addCustomClass(title)

    return key_values;
  }, [form_item, selectedData, setBlockSection, setBlockGroup, setBlockName]);


  useEffect(() => {
    const keyValues = getItemsWithData({ skip: true });
    const reqKeyValues = getItemsWithData({ skip: true, for_request_change_modal: true });
    setRequestChangeKeys(reqKeyValues)
    setKeyValues(keyValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form_item, selectedData]);

  const handleRequestChange = () => {
    setChangeList([...requestChangeKeys]);
    setShowModal(true);
  };
  const handleSectionChange = () => {
    setBlockSection(form_item?.section);
    setBlockGroup(form_item?.group);
    setShowModalOf({
      request_section_change: true,
    });
  };
  const handleEdit = () => {
    setBlockSection(form_item?.section);
    setBlockGroup(form_item?.group);
    setShowModalOf({
      edit: true,
    });
  };

  const handleRequestDocument = () => {
    setShowModalOf({
      request_document: true,
    });
  };

  const sendReminderEsign = async () => {
    let obj = {
      sub_wf_id: subworkflows?.length > 1 ? currentSubWorkFlowId : null,
      primary_wf_id: userSubworkFlowInfo?.primary_workflow_id,
      organisation_id: organisation_id
    }
    let resp = await dispatch(sendReminderForEsign(obj)).unwrap();
    if (resp?.status == "success") {
      setToastMessage({
        status: true,
        type: "success",
        message: resp?.message
      })
    } else if(resp?.status == "failed"){
      setToastMessage({
        status: true,
        type: "error",
        message: resp?.message
      })
    }
    setTimeout(() => {
      setToastMessage({
        status: false,
        type: "",
        message: ""
      })
    }, 3000);
  }


  const sendDynamicFormReminder = async (trigger) => {
      let redirectURL = "";
      const body = {
        is_primary: false,
        subWfId: selectedData?._id,
        userName: selectedData?.first_name,
        email_id: selectedData?.email,
        org_id: selectedData?.organisation_id,
        status: selectedData?.status,
        trigger:  trigger ? trigger : "send_reminder",
        link: redirectURL || selectedData?.link,
        application_ref_id : selectedData?.application_ref_id
      };
      let resp = await dispatch(sendreminderAboutStatus(body)).unwrap();
      if (resp?.status == "success") {
        setSendReminderToast({
          status: true,
          type: "success",
          message: resp?.message
        })
      } else if(resp?.status == "failed"){
        setSendReminderToast({
          status: true,
          type: "error",
          message: resp?.message
        })
      }
      setTimeout(() => {
        setSendReminderToast({
          status: false,
          type: "",
          message: "Unable to send reminder"
        })
      }, 3000);
  }

  const requestToCancelEmandate = async() => {
    let cancelMandateParams = {
      sub_wf_id: currentSubWorkFlowId,
      organisation_id: organisation_id
    }
    let resp = await dispatch(cancelEmandate(cancelMandateParams)).unwrap();
    if(resp?.status === "Failed"){
      setToastMessage({
        status: true,
        type: "error",
        message: resp?.message
      })
    } else {
      setToastMessage({
        status: true,
        type: "success",
        message: "Request sent for cancellation"
      })
    }
    setTimeout(() => {
      setToastMessage({
        status: false,
        type: "",
        message: ""
      })
    },3000);
  }

  const handlers = {
    [`${form_item?.name || ""}-request_change`]: handleRequestChange,
    [`${form_item?.name || ""}-request_section_change`]: handleSectionChange,
    [`${form_item?.name || ""}-edit`]: handleEdit,
    [`${form_item?.name || ""}-request_document`]: handleRequestDocument,
    [`${form_item?.name || ""}-send_reminder_esign`]:  sendReminderEsign,
    [`${form_item?.name || ""}-send_reminder`]: () => sendDynamicFormReminder(form_item?.trigger),
    [`${form_item?.name || ""}-cancel_mandate`]: requestToCancelEmandate,
  };

  const handleItemClick = (key_id,list_item) => {
    if(list_item?.role){
      setRoleValues(list_item.role)
    }
    if(list_item?.user){
      setUservalues(list_item.user)
    }
    if(list_item?.notification){
      setNotificationValues(list_item.notification)
    }
    if(list_item?.assignee_required && list_item?.assignee_required == 'true'){
      setAssigneeRequired('true')
    }else{
      setAssigneeRequired('false')
    }
    
    setblockId(key_id)
    if (typeof key_id === "string" && key_id.includes("custom_popups::")) {
      const action_of = key_id.replace("custom_popups::", "");
      if (form_item?.custom_popups?.[action_of]) {
        const customPopupConfig = form_item?.custom_popups[action_of];
        const approveObj = {
          _of: key_id,
          config: customPopupConfig,
        };
        setPopupState(approveObj);
        approveObj?.config?.form_elements && setShowPopModal(true);
      }
    }
    if (options?.customButton == true) {
      setcustomButton(true)
    }
    const handler = handlers[key_id];
    if (handler) {
      handler();
    }
  };


  const hideModalOf = (name) => {
    setShowModalOf({ [name]: false });
  };

  const handleSend = () => {
    const { email, full_name } = dashboardDetailData || {};
    const { userId: createdBy, first_name, last_name } = profileData || {};

    const params = {
      primaryWorkflowId: urlParams?.primaryWorkflowId,
      userId:
        userSubworkFlowInfo.user_id ||
        userSubworkFlowInfo.applicant_id ||
        userSubworkFlowInfo?.source_data?.applicant_id ||
        userSubworkFlowInfo?.source_data?.user_id,
      subWfId: currentSubWorkFlowId,
      organisation_id,
    };

    const body = {
      email,
      createdBy,
      name: full_name,
      requestedFlow: "edit",
      active_section: blockSection,
      active_group: blockGroup,
      blockName,
      internalUserName: `${first_name} ${last_name}`,
      // has_link_expiry: organisationInfo?.has_link_expiry,
      hours: organisationInfo?.setting?.link_expiry_duration_in_hours,
      customButton: customButton
    };
    dispatch(postRequestedDocs({ body, params }));
    hideModalOf("edit");
  };

  const [accordionProp,setAccodrionProp] = useState({})
  const [isMobile, setIsMobile] = useState(false)
  const checkWindowWidth = () => {
    const width = window.innerWidth;
    if (width <= 992) {
      if(name === 'account_details' || name === 'account_number' || name === 'v-kyc_queue'){
        setAccodrionProp({
          flush:true,
          activeKey:'0'
        })
      }
     else{
      setAccodrionProp({})
     }
      setIsMobile(true)
    } else if (width > 992) {
      setIsMobile(false)
      setAccodrionProp({
        flush:true,
        activeKey:'0'
      })
    }
  };

  useEffect(() => {
    checkWindowWidth();
  }, []);

  const addCustomClass = (data) => {
 
    if(data === 'Declarations'){
        setCustomClass(true)
    }
    else if(customClass){
      setCustomClass(false)
    }
  }
  const handleCrEdit = async ()=>{
    let err ={}
    if(Object.entries(popupData).length){
      let subworkflows = data?.primaryworkflow['subworkflows']
      Object.entries(popupData).map((item)=>{
        if(popupData[item[0]] != data?.subworkFlowInfo[item[0]]){
          subworkflows?.forEach((applicant)=>{
            if(applicant[item[0]] && applicant[item[0]] ==  item[1] ){
              err[item[0]] = { err:  `${item[0]?.replace("_"," ")} should be unique` }
            }
          })
        }
        
      })
    }
    if(Object.entries(err)?.length){
      setFormErr(err)
      return
    }else{
      setFormErr({})
    }
    if(Object.entries(popupData).length){
      let params = {
        ...popupData,_id:data?.subworkFlowInfo?._id
      }
      let dataaa = await updateCrData(params)
      window.location.reload()

    }else{
      setShowPopModal(false)
      setToastMessage({
        status: true,
        type: "error",
        message: "No changes detected"
      })

      setTimeout(()=>{
        setToastMessage({
          status: false,
          type: "",
          message: ""
        })

      },4000)
    }
    
  }
  // console.log("selectedData+++++++",options,selectedData);

  const clearFieldError = (fields, isList) => {
    fields = isList ? fields : [fields];
    let err = { ...formErr };

    for (let key in fields) {
      const _field = fields[key];
      if (err[_field] !== undefined) {
        delete err[_field];
      }
    }
    setFormErr(err);
  }

  const [accordionOpen, setAccordionOpen] = useState(false);

  const handleAccordionToggle = () => {
    setAccordionOpen(!accordionOpen);
  };

  const stopPropagation = (e) =>{
    e.stopPropagation()
  }

  return (
      <div>
          {toastMessage?.status && (
              <Toast
                  type={toastMessage?.type}
                  message={toastMessage?.message}
                  autoClose={3000}
              />
          )}
          {
            <div className="d-none d-lg-block">
            <ActionButtons
              selectedData={completeData}
              setSelectedData={setPopupData}
              popupConfig={popupState?.config || {}}
              form_buttons={[]}
              showPopModal={showPopModal}
              setShowPopModal={setShowPopModal}
              formErr={formErr}
              clearFieldError={clearFieldError}
              handleCrEdit={handleCrEdit}
            />
          </div>

          }
          {showModal && (
              <RequestChangeModal
                  show={showModal}
                  onHide={() => setShowModal(false)}
                  options={changeList}
                  blockGroup={blockGroup}
                  blockSection={blockSection}
                  blockName={blockName}
                  requestedFlow={'update'}
                  customButton={customButton}
                  paymentBlock={name === 'payment_details'}
                  block_data={selectedData?.block_data || {}}
                  assignee_required = {assigneeRequired || false}
                  request_change_option = {request_change_option || "role"}
                  role = {roleValues}
                  user = {userValues}
                  notification = {notificationValue}
              />
          )}

          {showModalOf?.['request_section_change'] && (
              <RequestSectionModal
                  show={showModalOf?.request_section_change}
                  onHide={() => hideModalOf('request_section_change')}
                  options={changeList}
                  blockGroup={blockGroup}
                  blockSection={blockSection}
                  blockName={blockName}
                  requestedFlow={'updateSection'}
                  subHeading="Are you sure you want user to edit this Section-"
                  editFontSize={'editFontSize'}
                  customButton={customButton}
                  formFields={form_item}
                  blockId={blockId}
                  assignee_required = {assigneeRequired || false}
                  request_change_option = {request_change_option || "role"}
                  role = {roleValues}
                  user = {userValues}
                  notification = {notificationValue}
              />
          )}
          {showModalOf?.['edit'] && (
              <ConfirmModal
                  handleConfirm={handleSend}
                  show={showModalOf?.edit}
                  onHide={() => hideModalOf('edit')}
                  title="Confirm?"
                  subHeading="Are you sure you want to edit?"
                  editFontSize={'editFontSize'}
              />
          )}
          {showModalOf?.['request_document'] && (
              <RequestSupportingDocuments
                  show={showModalOf?.request_document}
                  onHide={() => hideModalOf('request_document')}
                  title="Request Document"
                  inputFields={RequestDocumentConfig?.input_fields}
                  recursiveActions={RequestDocumentConfig?.recursive_actions}
                  recursiveTitle={RequestDocumentConfig?.title}
                  minLength={RequestDocumentConfig?.min_length}
                  maxLength={RequestDocumentConfig?.max_length}
                  assignee_required = {assigneeRequired || false}
                  request_change_option = {request_change_option || "role"}
                  role = {roleValues}
                  user = {userValues}
                  notification = {notificationValue}
              />
          )}

      <Fragment>
        <Accordion {...accordionProp} className={`${name === 'account_details' || name === 'account_number' ? 'mb-3' : ''}`}>
          <Accordion.Item
            eventKey="0"
            bsPrefix={'accordion-detailed-view bg-white'}
          >
            <Accordion.Header
              bsPrefix={`btn-style-reset scroll-margin-125px ${isMobile ? '' : 'btn-no-after'
                } ${name === 'account_details' || name === 'account_number' || name === 'v-kyc_queue' ? 'btn-no-after' : ''}`}
              id={`${name}-${index || 0}`}
              className="d-flex justify-content-between align-items-center z-index-1"
              onClick={handleAccordionToggle}
            >
              <div className="d-flex justify-content-between align-items-center">
              {name !== 'account_details' ? (accordionOpen ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-dash-lg d-lg-none" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-plus-lg d-lg-none" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                </svg>
              ) ) : ''}
              
              <span className="mx-2 mt-2">{title}{' '}</span>
              </div>
             
                <div onClick={(e)=>stopPropagation(e)}>
                {options &&
                eval(options?.show) &&
                keyValues.length ? (
                <DynamicForm
                  formFields={options}
                  selectedData={{
                    ...selectedData,
                    currentUserRole: data?.currentUserRole
                  }}
                  triggerItem={
                    <a className="cursor-pointer popover-btn d-lg-block">
                      {accordionOpen ? (
                        <Image className="option_button d-lg-none" imageSrc={option}/>
                      ) : null}
                      <Image className="option_button d-none d-lg-block" imageSrc={option} />
                    </a>
                  }
                  accordionOpen={accordionOpen}
                  handleItemClick={handleItemClick}
                  setSelectedData ={setSelectedData}
                  formErr={formErr}
                  setFormErr={setFormErr}
                  clearFieldError={clearFieldError}
                />
              ) : (
                ''
              )}
                </div>
            </Accordion.Header>
        

            <Accordion.Body bsPrefix="p-0">

              {/* <div className="text-end me-3 d-lg-none">
                        {options &&
                          eval(options?.show) &&
                          keyValues.length ? (
                              <DynamicForm
                                  formFields={options}
                                  selectedData={{
                                      ...selectedData,
                                      currentUserRole: data?.currentUserRole
                                  }}
                                  triggerItem={
                                      <a className="cursor-pointer popover-btn ">
                                          <Image
                                              className="option_button"
                                              imageSrc={option}
                                          />
                                      </a>
                                  }
                                  handleItemClick={handleItemClick}
                              />
                          ) : (
                              ''
                          )}
                        </div> */}
                          {userSubworkFlowInfoLoading &&
                              !noPlaceholderItems.includes(name) && (
                                  <PlaceHolderLoader />
                              )}
                          {keyValues.length ? (
                              //  {true ? (
                              form_item?.form_elements?.map((_item, index) => {
                                  const { input_fields, type } = _item;

                                  const primaryUser = selectedData;
                                  return (
                                      <>
                                          {(type === 'group' && eval(_item?.show) )? (
                                              <Container
                                                  fluid
                                                  className=""
                                              >
                                                  <Group
                                                      formFields={input_fields}
                                                      selectedData={
                                                          selectedData
                                                      }
                                                      primaryUser={primaryUser}
                                                      className={'bg-white'}
                                                  />
                                              </Container>
                                          ) : (
                                            //The detailview will display all other types using the eval condition mentioned below.
                                            //  eval(_item?.show) &&
                                              <Container fluid className="py-1">
                                                  <Row className={`gy-3 gy-lg-4 ${customClass ? 'px-3':'px-2'}`}>
                                                      <DynamicForm
                                                          formFields={_item}
                                                          selectedData={
                                                              {...selectedData, ...selectedDataFromRedux}
                                                          }
                                                          primaryUser={
                                                              primaryUser
                                                          }
                                                          allData={allData}
                                                          setSelectedData ={setSelectedData}
                                                          formErr={formErr}
                                                          setFormErr={setFormErr}
                                                          clearFieldError={clearFieldError}
                                                      />
                                                  </Row>
                                              </Container>
                                          )}
                                      </>
                                  );
                              })
                          ) : (
                              <>
                                  {userSubworkFlowInfoLoading &&
                                  !noPlaceholderItems.includes(name) ? (
                                      <PlaceHolderLoader />
                                  ) : (
                                      <div className="p-3 px-4">
                                          No Details Added
                                      </div>
                                  )}
                              </>
                          )}
                      </Accordion.Body>
                  </Accordion.Item>
              </Accordion>
          </Fragment>
      </div>
  );
}

      export default ViewBlockCard;
